<woo-modal-layout size="medium" (close)="close()">
    <inline-group header gap="small" class="alert-header">
        <div class="icon-wrapper text-danger display--inline margin--none">
            <span class="icon-warning-outline icon__large"></span>
        </div>
        @if(status()?.error) {
            <h3 class="alert-text">{{status().error || 'Hoppsan! Något gick fel.'}}</h3>
        }
    </inline-group>
    @if(status().message) {
        <div class="margin-top">
            @for(msg of status().message; track $index;) {
                <p>{{msg}}</p>
            }
        </div>
    }
    @if(status().details) {
        @for (detail of status().details| keyvalue; track $index) {
            <p>{{ detail.key }}</p>
            @for (text of detail.value; track $index;) {
              <p class="detailed-padding">{{ text }}</p>
            }
          }
    }
    <button id="close" [attr.e2e-id]="'close'" footer class="button primary-1 center display--block margin-top" (click)="close()">Stäng</button>
</woo-modal-layout>
